<script setup>
import { computed, defineAsyncComponent } from 'vue';
import { useRouter } from 'vue-router';

import TheFilterButtons from '@/components/Layout/Components/TheFilterButtons.vue';
import TheFooter from '@/components/Layout/Components/TheFooter.vue';
import TheHeader from '@/components/Layout/Components/TheHeader.vue';
import TheTitleSection from '@/components/Layout/Components/TheTitleSection.vue';
import VirtualAssistant from '@/components/Layout/Components/TheVirtualAssistant.vue';
import TheDevBar from '@/components/TheDevBar.vue';
import ErrorMessage from '@/components/Views/Funnels/shared/all-funnels/components/ErrorMessage.vue';
import { useTitleSectionContents } from '@/composables/useTitleSectionContents.js';
import { useVirtualAssistant } from '@/composables/useVirtualAssistant.js';
import { formStore } from '@/stores/form.js';
import { voertuigStore } from '@/stores/voertuig.js';

const form = formStore();
const { foto } = voertuigStore();
const router = useRouter();
const { assistantTitle, assistantExpertise, assistantBody } = useVirtualAssistant();
const { renderedTitle, renderedBody } = useTitleSectionContents();

const TheFilter = defineAsyncComponent(() => import(`@/components/Views/Funnels/${form.funnelType}/components/TheFilter.vue`));

const vehiclePhoto = () => {
  return foto.Url !== false && typeof foto.Url !== 'undefined' ? foto.Url : null;
};
const hideUspSection = computed(() => ['insuretostudy', 'eerdmans'].includes(form.tenant));
const hideChatBox = computed(() => ['insuretostudy', 'eerdmans'].includes(form.tenant));
const hideHelpCenter = computed(() => ['insuretostudy'].includes(form.tenant));
const hideFooter = computed(() => ['insuretostudy', 'eerdmans'].includes(form.tenant));
</script>

<template>
  <div class="wrapper">
    <TheDevBar v-if="form.getFunnelVersion === 'dev-local' || form.devMode" />
    <BaseSpinner v-if="form.baseSpinner" />
    <BaseLoader v-if="form.baseLoader" />
    <TheHeader
      :disabled-usp-section="hideUspSection"
      :disabled-chat-box="hideChatBox"
      :disabled-help-center="hideHelpCenter"
    />
    <!-- The app form -->
    <main>
      <div class="container-lg">
        <div class="row">
          <div class="col-12 col-sm-8 col-md-7 col-lg-6">
            <TheTitleSection
              :title="renderedTitle()"
              :body="renderedBody()"
              :photo="vehiclePhoto()"
            />
            <!-- The virtual assistant -->
            <ErrorMessage v-if="form.error" />

            <VirtualAssistant
              :name="form.specialist.name"
              :avatar="form.specialist.image_url"
              :title="assistantTitle()"
              :expertise="assistantExpertise()"
              :body="assistantBody()"
            />
          </div>
          <div class="col-12 col-sm-8 col-md-7 col-lg-6">
            <TheFilterButtons :save-for-later="!router.currentRoute?.value.meta?.hideSaveForLater" />
          </div>
          <aside class="d-none d-lg-block col-md-3 offset-md-1 col-lg-3 offset-lg-0">
            <!-- Op mobile is it a off canvas -->
            <BaseCard title="Filters">
              <component :is="TheFilter" />
            </BaseCard>
          </aside>
          <div class="col-12 col-sm-8 col-md-7 col-lg-9 pb-5">
            <slot />
          </div>
        </div>
      </div>
    </main>
    <!-- The footer -->
    <TheFooter v-if="!hideFooter" />
  </div>
</template>
